import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import DefaultButton from '../molecules/DefaultButton';
import RowCenterButton from '../molecules/RowCenterButton';
import TransitionButton from '../molecules/TransitionButton';

interface Props {
  reception_cd: string;
  reception_id: number;
  status_code: number;
  moveNextStep: () => void;
  movePrevStep: () => void;
  is_change: boolean;
}

// KWANKGM04020_借入申込書類提出フッタボタン
const FooterExaminationApplicantUpload: React.FC<Props> = ({
  reception_cd,
  reception_id,
  status_code,
  moveNextStep,
  movePrevStep,
  is_change,
}) => {
  const history = useHistory();
  // URLパラメータに商品IDが付与されているか
  const url = new URL(window.location.href);
  const has_item_id = url.searchParams.has('item_id');
  /**
   * ナビゲーションを次に遷移
   * 画面をKWANKGM04030_借入申込入力（確認）に遷移
   */
  const handleClickNext = () => {
    moveNextStep();
    if (has_item_id) {
      const item_id = url.searchParams.get('item_id');
      history.push({
        pathname: `/reception/${reception_cd}/${reception_id}/${status_code}/final_confirm`,
        search: `?item_id=${item_id}`,
      });
    } else {
      history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/final_confirm`);
    }
  };

  /**
   * ナビゲーションを前に遷移
   * 画面をKWANKGM04010_借入申込詳細に遷移
   */
  const handleClickPrev = () => {
    movePrevStep();
    if (has_item_id) {
      const item_id = url.searchParams.get('item_id');
      history.push({
        pathname: `/reception/${reception_cd}/${reception_id}/${status_code}`,
        search: `?item_id=${item_id}`,
      });
    } else {
      history.push(`/reception/${reception_cd}/${reception_id}/${status_code}`);
    }
  };
  return (
    <>
      <RowCenterButton>
        <DefaultButton
          label={is_change ? '変更書類を提出する' : '書類を提出する'}
          strong={false}
          handleClick={handleClickNext}
        />
      </RowCenterButton>
      <TransitionButton label="戻る" handleClick={handleClickPrev} />
    </>
  );
};

export default memo(FooterExaminationApplicantUpload);
